module.exports = __webpack_public_path__ + "img/818002207_4.5e9d03ad.jpg";